import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { SubrentalEntryImportModel } from 'src/app/models/imports/subrental-entry-import.model';
import { InventoryEntryDetailModel } from 'src/app/models/inventory/inventory-entry-detail.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { RentalStockModel } from 'src/app/models/rental/rental-stock-response.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ArticleSelectionTableModel } from 'src/app/models/tables/archive/article-selection-table.model';
import { SubrentalEntryDetailCaptureTableModel } from 'src/app/models/tables/subrental/subrental-entry-detail-capture-table.model';
import { SubrentalEntryDetailTableModel } from 'src/app/models/tables/subrental/subrental-entry-detail-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubrentalEntryDetailService {

  constructor(private _httpClient: HttpClient) { }

  exportDetailConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams()
      .set('columnSort', columnSort ?? '')
      .set('ascendant', ascendant.toString());

    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalEntryDetail.ExportDetailConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }


  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalEntryDetail.ExportImportErrors}`, alerts,
      {
        responseType: 'blob'
      }
    );
  }

  getAllArticlesForSubrentalEntriesForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalEntryDetail.GetAllArticlesForSubrentalEntriesForSelectAsync}`);
  }

  getColumnsForDetailConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalEntryDetail.GetColumnsForDetailConsultation}`);
  }

  getColumnsForArticles(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalEntryDetail.GetColumnsForArticles}`);
  }

  getColumnsForDetailCapture(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalEntryDetail.GetColumnsForDetailCapture}`);
  }

  getArticlesForEntries(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<ArticleSelectionTableModel>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<ArticleSelectionTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalEntryDetail.GetArticlesForEntries}`,
      filters, { params: params }
    );
  }

  getSubrentalEntryDetailsForDetailConsultation(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<SubrentalEntryDetailTableModel>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<SubrentalEntryDetailTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalEntryDetail.GetSubrentalEntryDetailsForDetailConsultation}`,
      filters, { params: params }
    );
  }

  getSubrentalEntryDetailsForCapture(subrentalEntryId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean): Observable<PagedResponseModel<SubrentalEntryDetailCaptureTableModel>> {
    const params = new HttpParams()
      .set('subrentalEntryId', subrentalEntryId)
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.get<PagedResponseModel<SubrentalEntryDetailCaptureTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalEntryDetail.GetSubrentalEntryDetailsForCapture}`,
      { params: params }
    );
  }

  getSubrentalEntryDetailById(subrentalEntryDetailId: number): Observable<InventoryEntryDetailModel> {
    return this._httpClient.get<InventoryEntryDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalEntryDetail.GetSubrentalEntryDetailById}/${subrentalEntryDetailId}`);
  }

  createSubrentalEntryDetail(subrentalEntryDetailContract: InventoryEntryDetailModel): Observable<InventoryEntryDetailModel> {
    return this._httpClient.post<InventoryEntryDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalEntryDetail.CreateSubrentalEntryDetail}`,
      subrentalEntryDetailContract);
  }

  updateSubrentalEntryDetail(subrentalEntryDetailContract: InventoryEntryDetailModel): Observable<InventoryEntryDetailModel> {
    return this._httpClient.put<InventoryEntryDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalEntryDetail.UpdateSubrentalEntryDetail}`,
      subrentalEntryDetailContract);
  }

  deleteSubrentalEntryDetail(subrentalEntryDetailId: number): Observable<InventoryEntryDetailModel> {
    return this._httpClient.delete<InventoryEntryDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalEntryDetail.DeleteSubrentalEntryDetail}/${subrentalEntryDetailId}`);
  }

  deleteSomeDetails(subrentalEntryDetailIds: Array<number>): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalEntryDetail.DeleteSomeDetails}`,
      subrentalEntryDetailIds);
  }

  getStocksByArticleIdStoreId(rentalStockModel: RentalStockModel): Observable<number> {
    return this._httpClient.post<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalEntryDetail.GetStocksByArticleIdStoreId}`,
      rentalStockModel);
  }

  getSubrentalEntryDetailByEntryId(subrentalEntryId: number): Observable<Array<InventoryEntryDetailModel>> {
    return this._httpClient.get<Array<InventoryEntryDetailModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalEntryDetail.GetSubrentalEntryDetailByEntryId}/${subrentalEntryId}`);
  }

  getSubrentalEntryDetailByKeys(inventoryEntryId: number, storeId: number, articleId: number): Observable<InventoryEntryDetailModel> {
    const params = new HttpParams()
      .set('inventoryEntryId', inventoryEntryId)
      .set('storeId', storeId)
      .set('articleId', articleId)
    return this._httpClient.get<InventoryEntryDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalEntryDetail.GetSubrentalEntryDetailByKeys}`,
      { params: params });
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalEntryDetail.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  importSubrentalEntry(subrentalEntryImports: Array<SubrentalEntryImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.put<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalEntryDetail.ImportSubrentalEntry}`,
      subrentalEntryImports);
  }
}
